import React from 'react'
import Modal from '../../../../common/modal/Modal'
import Button from '../../../../common/button/Button'
import { useCourseReport } from '../../ReportingGroup/context/CourseReportContext'
import UserProfile from './content/UserProfile'
import Icons from '../../../../common/icons/Icons'
import CourseContentNavigation from '../../ReportingGroup/UserProgress/CourseContentNavigation'
import MicroModal from "micromodal"
import { useUserReport } from '../../ReportingGroup/context/UserReportContext'

const CourseUserDetails = ({ from = 'course-report' }) => {
    MicroModal.init()

    const { selectedCourse, selectedUser, courseDetails } = from === 'course-report' ?  useCourseReport() : useUserReport()
    
    const handleBackToCourse = () => {
        MicroModal.close(`msync-report-user-container`)
        MicroModal.show( from === 'course-report' ? 
                        `msync-course-report-course-container` :
                        'msync-report-user-course-list')
    }

    return (
        <Modal 
            modalId={`msync-report-user-container`} 
            buttonTitle={''} 
            showModalHeader={ false }
            classNames={''} 
            containerClassNames={'msync-report-user-container'}
        >
            <header className="msync-modal__header">
                <div className="msync-modal__header__title">
                    <Button 
                        onClick={ handleBackToCourse }
                    >
                        <Icons type="arrow-tail-left" />
                        <span className="msync-visually-hidden">Back</span>
                    </Button>
                    <h2 className="msync-modal__header__title__text msync-modal__title">{selectedCourse.course && selectedCourse.course}</h2>
                </div>
                
                <Button 
                  className="msync-modal__close" 
                  aria-label="Close modal" 
                  onClick={()=>MicroModal.close(`msync-report-user-container`)}
                >
                  <Icons type='close' />
                  <span className="msync-visually-hidden">Close <kbd>ESC</kbd></span>
                </Button>
            </header>
            <main className="msync-modal__body msync-modal__body--has-table msync-reporting__detail" key={selectedUser.userId}>
                { ( selectedUser && selectedCourse) && <UserProfile from={from} /> }
                { ( courseDetails && selectedUser ) && <CourseContentNavigation from={from} /> }
            </main>
        </Modal>
    )
}

export default CourseUserDetails